<!--
	{
		message: ...,
		header: ...,can be null - optional header of the notifying, for type "error" or "warning" and header = null, header will be automatically set to "error!" and "warning!"
		type:		"message" or "info" or "error" or "warning", default "message"
		hold:		true - after mouseover the message will not disappear, default "true"
		delay:	time in usecs before disappearing, "0" for permanent, default - delay from props
	}

	click on close sing will close a notifying
	click on body will close a notifying with types differ from "error" and "warning"
	click on body with shift close any notifying
	mouseover on notification baloon makes it "holded", if hold was true for this notifying
-->
<template>
	<div class="notifyWrapper">
		<transition-group name="toast" tag="div" mode="in-out">
			<div class="notification" :class="[ item.type, !item.tid || item.delay == 0 ? 'holded' : '' ]" v-for="item in items" :key="item.id">
				<div
          class="content"
          @mouseover="stop( item )"
          @click="removeByBodyClick( item )"
          @click.shift="remove( item )"
          @mousedown.shift.prevent=""
        >
    			<div class="icon close" @click="remove( item )">✖</div>
          <div
            class="timeLine"
            :style="{ 'animation-duration': item.delay + 'ms' }"
          />
          <div class="scroller">
            <div class="header" v-if="item.header || item.type=='warning' || item.type=='error'">
              <template v-if="item.header">{{ item.header }}</template>
              <template v-else-if="item.type=='warning'">{{ $t( "warning" ) }}</template>
              <template v-else-if="item.type=='error'">{{ $t( "error" ) }}</template>            </div>
            <span v-html="item.message"></span>
          </div>
				</div>
			</div>
		</transition-group>
	</div>
</template>

<script>
export default {
	name: "Notify",

	components: {},

  i18n: {
    messages: {
      ru: {
        warning: "внимание!",
        error:   "ошибка!",
      },

      en: {
        warning: "warning!",
        error:   "error!",
      },

      kz: {
        warning: "ескерту!",
        error:   "қате!",
      }
    }
  },

	props: {
		delay: {
			type:	Number,
			default:3000		},
    delayWarnings: {
		  type: Number,
      default:0
    },
    delayErrors: {
		  type: Number,
      default:0
    },
	},
	data() {
		return {
			items: [],
			id: 0
		};
	},
	created() {
		this.pe = e => { this.add( e ); };

		//this.$parent.$on( "notify", this.pe );
		this.$root.$on( "notify", this.pe );
	},
	beforeDestroy() {
		//this.$parent.$off( "notify", this.pe );
		this.$root.$off( "notify", this.pe );
	},
	methods: {
		add( msg, type ) {
			const item = {
				id: this.id++,
				header:	null,
				message:null,
				type:	"info",
				delay:	null,
				hold:	true
			};

			if ( typeof( msg ) === "object" ) {
				item.message = msg.message || msg.text;
				type = msg.type;
				if ( "delay" in msg ) {
					const t = parseInt( msg.delay, 10 );
					if ( !isNaN( t ) ) item.delay = t;
				}
				if ( "hold" in msg ) item.hold = !!msg.hold;
				if ( "header" in msg ) item.header = msg.header;
      }
			else item.message = msg;

			switch ( ( "" + type ).toLowerCase() ) {
				case "error":
					item.type = "error";
				break;

				case "warning":
					item.type = "warning";
				break;

				case "info":
				default:
					item.type = "info";
			}

			if ( item.delay === null ) {
			  if ( item.type == "warning" ) item.delay = this.delayWarnings;
			  else if ( item.type == "error" ) item.delay = this.delayErrors;
			  else item.delay = this.delay;
      }

			if ( item.delay ) this.$set( item, "tid", setTimeout( () => { this.remove( item ) }, item.delay ) );

			this.items.push( item );
		},

    _stop( item ) {
		  if ( item ) {
		    if ( item.tid ) clearTimeout( item.tid );
		    this.$set( item, "tid", null );
		    item.delay = 0;
      }
    },

		remove( item ) {
		  this._stop( item );

			const itemIndex = this.items.findIndex( i => i === item );
			if ( itemIndex >= 0 ) this.items.splice( itemIndex, 1 );
		},

		removeByBodyClick( item ) {
			if ( item.type !== 'error' && item.type !== 'warning' ) this.remove( item );
		},

		stop( item ) {
			if ( item.hold ) this._stop( item );
		}
	}
};
</script>

<style scoped>
.notifyWrapper {
	display: inline-block;
	position: fixed;
	right: 0;
	bottom: 0;
	overflow: hidden;
	z-index: 10000;
}

.notifyWrapper .notification {
	font: inherit;
	position: relative;
	font-size: 0.8em;
	transition: all .35s ease;
	text-align: right;
  margin-bottom: 0.1em;
}
.notifyWrapper .notification > .content > .close {
  position: absolute;
  z-index: 1;
  color: #FFFFFF;
  left: 0.3em;
  top: 0.1em;
  font-size: 0.8em;
  cursor: pointer;
  border-radius: 100%;
  transition: all .15s linear;
/*
	text-shadow:
		-0   -1px 0   #FFFFFF,
		0   -1px 0   #FFFFFF,
		-0    1px 0   #FFFFFF,
		0    1px 0   #FFFFFF,
		-1px -0   0   #FFFFFF,
		1px -0   0   #FFFFFF,
		-1px  0   0   #FFFFFF,
		1px  0   0   #FFFFFF,
		-1px -1px 0   #FFFFFF,
		1px -1px 0   #FFFFFF,
		-1px  1px 0   #FFFFFF,
		1px  1px 0   #FFFFFF,
		-1px -1px 0   #FFFFFF,
		1px -1px 0   #FFFFFF,
		-1px  1px 0   #FFFFFF,
		1px  1px 0   #FFFFFF;
*/
}
.notifyWrapper .notification > .close:hover {
	text-shadow:
		-0   -1px 0   rgba( 0, 0, 0, .3 ),
		 0   -1px 0   rgba( 0, 0, 0, .3 ),
		-0    1px 0   rgba( 0, 0, 0, .3 ),
		 0    1px 0   rgba( 0, 0, 0, .3 ),
		-1px -0   0   rgba( 0, 0, 0, .3 ),
		 1px -0   0   rgba( 0, 0, 0, .3 ),
		-1px  0   0   rgba( 0, 0, 0, .3 ),
		 1px  0   0   rgba( 0, 0, 0, .3 ),
		-1px -1px 0   rgba( 0, 0, 0, .3 ),
		 1px -1px 0   rgba( 0, 0, 0, .3 ),
		-1px  1px 0   rgba( 0, 0, 0, .3 ),
		 1px  1px 0   rgba( 0, 0, 0, .3 ),
		-1px -1px 0   rgba( 0, 0, 0, .3 ),
		 1px -1px 0   rgba( 0, 0, 0, .3 ),
		-1px  1px 0   rgba( 0, 0, 0, .3 ),
		 1px  1px 0   rgba( 0, 0, 0, .3 );
}
.notifyWrapper .notification > .content > .timeLine {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 3px;
  background-color: rgba( 0, 0, 0, 0.3 );
  z-index: 1;
  animation: timeLineA 100ms linear;
  pointer-events: none;
	border-radius: 0.2em;
}
@keyframes timeLineA {
  from {
    width: 100%;
    visibility: visible;
  }

  to {
    width: 0;
    visibility: hidden;
  }
}
.notifyWrapper .notification > .content {
	text-align: left;
	position: relative;
	display: inline-block;
	font: inherit;
	font-weight: normal;
	padding: 0.9em 0.7em 0.7em 0.7em;
	background-color: #02CCBA;
	color: #FFFFFF;
	border-radius: 0.2em;
	box-shadow: 1px 1px 2px rgba( 0, 0, 0, 0.7 );
}

.notifyWrapper .notification > .content > .scroller {
	white-space: normal;
	word-break: break-word;
	max-width: 25em;
	max-height: 10em;
	overflow: auto;
}


.notifyWrapper .notification > .content > .scroller > .header {
	margin-bottom: 0.5em;
  font-weight: bold;
}

.notifyWrapper .info > .content {
	background-color: #68CD86;
  color: #104D23;
}

.notifyWrapper .warning > .content {
	background-color: #FFB648;
  color: #733600;
}

.notifyWrapper .error > .content {
	background-color: #E54D42;
  color: #FFFFFF;
}

.notifyWrapper .holded > .content {
	box-shadow: 0 0 3px rgba( 0, 0, 0, 0.7 ) inset;
}

.toast-enter,
.toast-leave-to {
	/*opacity: 0;*/
	transform: translateX( 100% );
}

.toast-enter-active,
.toast-leave-active {
}
</style>
